import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RecipeFacetArgs } from '../model/recipe-facet-args.model';
import { prediggoTranslation } from '@assets/prediggoObject';
import { SfSiteInfo, SITE_INFO, SfLocalizeService } from '@app/sf-lib/public_api';
import { isPlatformServer } from '@angular/common';
import { FacetNotFoundService } from '@app/shared/facet-not-found/facet.not-found.service';

@Injectable({
  providedIn: 'root'
})
export class RecipeFacetResolver  {
  private localize = inject(SfLocalizeService);
  private facetNotFound = inject(FacetNotFoundService);
  private platformId = inject(PLATFORM_ID);
  private siteInfo = inject<SfSiteInfo>(SITE_INFO);

  private getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  }

  private translateSegments(segments: string[]): string[] {
    const x: string[] = [];
    for (let i = 0; i < segments.length / 2; i++) {
      x.push(`${segments[i * 2]}/${segments[i * 2 + 1]}`);
    }
    const y: string[] = [];
    x.forEach(val => {
      if (this.getKeyByValue(prediggoTranslation[this.localize.currentLang.code], val)) {
        y.push(this.getKeyByValue(prediggoTranslation[this.localize.currentLang.code], val));
      } else {
        if (isPlatformServer(this.platformId)) {
          this.facetNotFound.checkRedirection(this.siteInfo.path);
        }
        y.push(val);
      }
    });
    segments = y.join('/').split('/');
    return segments;
  }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): RecipeFacetArgs {

    // decode spaces and specials caracters in url
    const url = decodeURI(state.url.split('?')[0]);

    let segments: string[];
    if (this.localize.currentLang.default) {
      // remove the first element => /{routeName}
      segments = url.split('/').slice(2).filter(Boolean);
    } else {
      // Remove the 2 first segment => /{langcode}/{routeName}
      segments = url.split('/').slice(3).filter(Boolean);
    }
    const res = new RecipeFacetArgs();

    // theme is the 2nd element.
    if (segments.length >= 1 && segments.length % 2 === 1) {
      res.themeName = segments.shift();
    }

     // translation
    segments = this.translateSegments(segments).filter(Boolean);

    res.facets = {};
    if (segments.length > 1) {
      for (let i = 0; i < segments.length / 2; i++) {
        if (res.facets[segments[i * 2]]) {
          (res.facets[segments[i * 2]] as string[]).push(segments[i * 2 + 1].replace(/%20/g, ' '));
        } else {
          res.facets[segments[i * 2]] = [segments[i * 2 + 1].replace(/%20/g, ' ')];
        }
      }
    }
    return res;
  }
}
